// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");

function tlFromStrings(ss) {
  return Belt_List.fromArray(Belt_Array.map(ss, (function (s) {
                    return [
                            0,
                            s
                          ];
                  })));
}

function tlShift(t, n) {
  return Belt_List.map(t, (function (param) {
                return [
                        param[0] + n | 0,
                        param[1]
                      ];
              }));
}

function tlMap(t, f) {
  return Belt_List.toArray(Belt_List.mapWithIndex(t, (function (idx, param) {
                    return Curry._3(f, idx, param[0], param[1]);
                  })));
}

var tlConcat = Belt_List.concat;

var tlConcatAll = Belt_List.concatMany;

exports.tlFromStrings = tlFromStrings;
exports.tlShift = tlShift;
exports.tlConcat = tlConcat;
exports.tlConcatAll = tlConcatAll;
exports.tlMap = tlMap;
/* No side effect */
